import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=95855778&scoped=true&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=95855778&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95855778",
  null
  
)

export default component.exports